<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.customer-segments.form.name')"
            :is-required="true"
            :error="errors.name"
            :hint="__('settings.customer-segments.form.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                :is-valid="isFormFieldValid('name')"
                maxlength="32"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.customer-segments.form.active')"
            :is-required="true"
            :hint="__('settings.customer-segments.form.active_hint')"
        >
            <DSwitch
                v-model="form.active"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.customer-segments.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'CustomerSegmentsForm',
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        customerSegment: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.customerSegment?.name ?? null,
                active: this.customerSegment?.active ?? false
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
